export const GuideTargetsUpdatedTypes = {
  GUIDE_TARGETS_UPDATED: '[Guide Targets] Guide Targets Updated',
} as const;

export interface GuideTargetsUpdatedEventPayload {
  yearMo?: number;
  updatedBy?: string;
}

export class GuideTargetsUpdatedEvent {
  readonly type = GuideTargetsUpdatedTypes.GUIDE_TARGETS_UPDATED;

  constructor(public payload: GuideTargetsUpdatedEventPayload) {}
}
